<script lang="ts" setup>
export interface PageHeaderSearchProps {
    action: string
    title: string
    headingType: string
}

export interface PageHeaderSearchEmits {
    // eslint-disable-next-line no-unused-vars
    (e: 'submit', value: string): void
}

const props = defineProps<PageHeaderSearchProps>()
const emits = defineEmits<PageHeaderSearchEmits>()
const route = useRoute()
const query = ref<string>(`${route.query.q || ''}`)
const inputRef = ref<HTMLInputElement | null>(null)

const { data, sendEvent } = useTracker()

const clearQuery = (): void => {
    query.value = ''
    nextTick(() => {
        inputRef.value?.focus()
    })
}

const handleSubmit = () => {
    emits('submit', query.value)
    sendEvent({
        data: {
            ...data,
            title: props.title,
            event: 'submit',
        },
    })
}
</script>
<template>
  <div class="row g-0 justify-content-between align-items-center">
    <PageHeaderTitle
      :type="props.headingType"
      class="text-start col-12 col-md-6 mb-3 mb-md-0 flex-grow-1"
    >
      {{ props.title }}
    </PageHeaderTitle>

    <form
      method="GET"
      :action="props.action"
      class="d-flex col-12 col-md-5"
      @submit.prevent="handleSubmit"
    >
      <div
        class="d-flex align-items-center bg-white rounded-4 flex-grow-1 border border-black-10"
      >
        <input
          ref="inputRef"
          v-model="query"
          class="page-header-search-input bg-white border-0 rounded-3 d-block px-2 px-md-3 flex-grow-1 w-100 order-2"
          :placeholder="$t('Vyhľadávanie')"
          :aria-label="$t('Vyhľadávanie')"
          autocomplete="off"
          type="search"
          name="faq-q"
        >
        <button
          v-if="query.trim().length > 0"
          type="button"
          class="page-header-search-clear order-2 flex-shrink-0 border-0 bg-transparent p-2 d-flex align-items-center justify-content-center text-black-100"
          :aria-label="$t('Vymazať vyhľadávanie')"
          @click="clearQuery"
        >
          <svg
            aria-hidden="true"
            width="14"
            height="14"
            class="d-block"
          >
            <use xlink:href="#times" />
          </svg>
        </button>
        <VButton
          type="submit"
          color="primary"
          size="large"
          class="order-3 flex-shrink-0"
          :label="$t('Hľadať')"
        >
          {{ $t('Hľadať') }}
        </VButton>
        <svg
          aria-hidden="true"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          class="d-none d-md-block order-1 ms-3 flex-shrink-0"
        >
          <path
            d="M8.23413,16.46829c2.00732,0 3.84729,-0.7244 5.27759,-1.92195l4.92688,4.92683c0.14282,0.14293 0.3302,0.21414 0.5614,0.21414c0.14294,0 0.3302,-0.07121 0.47314,-0.21414c0.28589,-0.28586 0.28589,-0.74879 0,-1.03464l-4.92676,-4.92683c1.198,-1.43025 1.92188,-3.27026 1.92188,-5.27757c0,-4.54048 -3.6936,-8.23415 -8.23413,-8.23415c-4.54053,0 -8.23413,3.69366 -8.23413,8.23415c0,4.54001 3.6936,8.23415 8.23413,8.23415M8.23413,1.46341c3.76587,0 6.76587,3.03756 6.76587,6.77073c0,3.76586 -3,6.76586 -6.76587,6.76586c-3.73315,0 -6.77075,-3 -6.77075,-6.76586c0,-3.73317 3.0376,-6.77073 6.77075,-6.77073"
            fill="#1d2127"
          />
        </svg>
      </div>
    </form>
  </div>
</template>
<style lang="scss">
@import './PageHeaderSearch.vars.scss';
</style>
<style lang="scss" scoped>
@import './PageHeaderSearch.scss';
</style>
